import * as React from 'react';
import { alpha, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Iconify from './Iconify';
import useConfirm from '../hooks/useConfirm';

const INDIGO = '#4F46E5';

const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    borderRadius: 20,
    boxShadow: '0 20px 60px rgba(15,23,42,0.15)',
    border: '1px solid #E2E8F0',
    overflow: 'hidden',
    minWidth: 340,
  },
}));

const IconCircle = styled('div')(() => ({
  width: 68,
  height: 68,
  borderRadius: '50%',
  background: alpha('#EF4444', 0.1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 16,
}));

export default function ConfirmDialog() {
  const { onConfirm, onCancel, confirmState } = useConfirm();

  return (
    <StyledDialog
      open={confirmState.show}
      onClose={onCancel}
      aria-labelledby="confirm-dialog"
    >
      {/* Top accent strip */}
      <Box sx={{
        height: 3,
        background: 'linear-gradient(90deg, #EF4444, #F97316)',
      }} />

      <DialogContent sx={{ pt: 4, pb: 2, px: 3 }}>
        <Stack alignItems="center" textAlign="center">
          <IconCircle>
            <Iconify
              icon="akar-icons:triangle-alert"
              sx={{ width: 32, height: 32, color: '#EF4444' }}
            />
          </IconCircle>

          <Typography variant="h6" sx={{ color: '#0F172A', fontWeight: 700, mb: 1, letterSpacing: '-0.01em' }}>
            Are you sure?
          </Typography>

          <Typography variant="body2" sx={{ color: '#64748B', lineHeight: 1.6, maxWidth: 280 }}>
            {confirmState.message}
          </Typography>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, gap: 1.5, justifyContent: 'center' }}>
        <Button
          onClick={onCancel}
          variant="outlined"
          sx={{
            borderRadius: '10px',
            px: 3,
            color: '#475569',
            borderColor: '#E2E8F0',
            fontWeight: 600,
            textTransform: 'none',
            '&:hover': { borderColor: '#CBD5E1', background: '#F8FAFC' },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            borderRadius: '10px',
            px: 3,
            fontWeight: 600,
            textTransform: 'none',
            background: 'linear-gradient(135deg, #EF4444, #B91C1C)',
            boxShadow: '0 4px 14px rgba(239,68,68,0.35)',
            '&:hover': {
              background: 'linear-gradient(135deg, #B91C1C, #7F1D1D)',
              boxShadow: '0 6px 20px rgba(239,68,68,0.5)',
              transform: 'translateY(-1px)',
            },
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </StyledDialog>
  );
}
